import { useApp } from "@/context/AppContext";
import { FileImage } from "@/components/files/FileFields";

export function DocHeader({ title, sub, center }) {
  const { view } = useApp();
  const shop = view.shop || {};
  if (center) {
    return (
      <div className="text-center border-b border-dashed border-foreground/40 pb-2 mb-2" data-testid="doc-header">
        {shop.logo_id && <FileImage id={shop.logo_id} className="w-14 h-14 object-contain mx-auto mb-1" alt={shop.name} />}
        <div className="text-lg font-bold">{title}</div>
        <div className="font-bold">{shop.name}</div>
        {sub}
      </div>
    );
  }
  return (
    <div className="flex items-center gap-3" data-testid="doc-header">
      {shop.logo_id && <FileImage id={shop.logo_id} className="w-12 h-12 object-contain" alt={shop.name} />}
      <div><div className="text-lg font-extrabold text-[#1F4E8C]">{title}</div><div className="text-xs text-[#555]">{shop.name}{shop.address ? ` · ${shop.address}` : ""}{shop.phone ? ` · ${shop.phone}` : ""}</div>{sub}</div>
    </div>
  );
}
